import css from 'styled-jsx/css';

const staticStyles = css`
  .CreateTemplateForm {
    :global(.ReduxSelectField) {
      max-width: 300px;
      width: 100%;
    }

    &__langHint {
      display: inline-block;
      margin-top: 3px;
      margin-bottom: 30px;
      font-size: 12px;
      color: #9e9e9e;
    }

    &__btns {
      :global(.DefaultButton) {
        margin-right: 30px;
      }
    }
  }
`;

export default staticStyles;
